import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormlyModule } from '@ngx-formly/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';
import { MenuService } from '../../../services';
import { FormlyProps } from '../../../models';

@Component({
  selector: 'app-formly-select',
  templateUrl: './formly-select.component.html',
  styleUrl: './formly-select.component.scss',
  imports: [NgSelectComponent, FormsModule, ReactiveFormsModule, FormlyModule, AsyncPipe],
})
export class FormlySelectComponent extends FormlyFieldBaseComponent {
  protected readonly menuService = inject(MenuService);

  defaultOptions = {
    props: { options: [] },
  };

  get showCreate(): boolean {
    return this.props.create && (!this.props.showCreate || this.props.showCreate(this.model));
  }

  get showUpdate(): boolean {
    return this.props.update && (!this.props.showUpdate || this.props.showUpdate(this.model));
  }

  get showDelete(): boolean {
    return this.props.delete && (!this.props.showDelete || this.props.showDelete(this.model));
  }

  getValue(options: FormlyProps[]) {
    const value = this.model[this.key as string];
    return value ? options.find((option: FormlyProps) => option.value === value)?.label : '';
  }

  onCreate(event: any) {
    if (this.props.create) {
      this.props.create(event);
    }
  }

  onUpdate(event: any) {
    if (this.props.update) {
      this.props.update(event);
    }
  }

  onDelete(event: any) {
    if (this.props.delete) {
      this.props.delete(event);
    }
  }
}
